export default __webpack_public_path__ + "static/media/promo-gem-visa.c7126a0f.png";